import { render } from "./GeneralMedicine.vue?vue&type=template&id=2c58ad8a&scoped=true"
import script from "./GeneralMedicine.vue?vue&type=script&lang=ts"
export * from "./GeneralMedicine.vue?vue&type=script&lang=ts"

import "./GeneralMedicine.vue?vue&type=style&index=0&id=2c58ad8a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c58ad8a"

export default script